import { CompanyFilters } from "./../model/companydetails";
import {
  Http,
  Response,
  Headers,
  Request,
  RequestOptions,
} from "@angular/http";
import { throwError as observableThrowError, Observable, BehaviorSubject } from "rxjs";
import { AuthHeaderService } from "../views/authheader.service";
import { environment } from "../../environments/environment";
import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";

@Injectable()
export class CompanyService {
  companyurl: string;
  newcompanyurl: string;
  getcompanyurl: string;
  userdetailsurl: string;
  companyconfigurationurl: string;
  currentEnv: string;
  URL: string;
  roleurl: string;
  linkedcompanyurl: string;
  forgotpasswordurl: string;
  validatepasswordurl: string;
  userManagementurl: string;
  emailLogsurl: string;
  carrierRatecon: string;
  userRolesSubject = new BehaviorSubject<any>([]);
  getUserRoles = this.userRolesSubject.asObservable();
  resetpasswordurl:string;
  public updateCompany : any = "krishna";
  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.companyurl = environment.companyurl;
    this.currentEnv = environment.URL;
    this.URL = environment.url;
    this.roleurl = environment.roledetailsUrl;
    this.newcompanyurl = environment.newcompanyurl;
    this.userdetailsurl = environment.userdetailsurl;
    this.userManagementurl = environment.userManagementurl;
    this.forgotpasswordurl = environment.forgotpasswordurl;
    this.validatepasswordurl = environment.validateupdatepasswordurl;
    this.resetpasswordurl =  environment.resetpasswordurl;
    this.emailLogsurl = environment.emailLogs;
    this.getcompanyurl = environment.getcompanydetails;
    this.companyconfigurationurl = environment.companyconfigurationurl;
    this.carrierRatecon = environment.carrierRatecon;
    this.userRolesSubject.next(this.userRoles);
  }

  userRoles =
    [{ roleId: 1, roleDescription: "Super Admin" },
    { roleId: 2, roleDescription: "Support" },
    { roleId: 3, roleDescription: "Admin" },
    { roleId: 5, roleDescription: "Dispatcher" },
    { roleId: 6, roleDescription: "Driver" },
    { roleId: 7, roleDescription: "Carrier" },
    { roleId: 8, roleDescription: "Customer" },
    { roleId: 9, roleDescription: "Carrier Admin" },
    { roleId: 10, roleDescription: "Maintenance Admin" },
    { roleId: 11, roleDescription: "Billing Admin" },
    { roleId: 12, roleDescription: "Safety Admin" },
    { roleId: 13, roleDescription: "Estimator" },
    { roleId: 14, roleDescription: "Accounts Payable" },
    ]


  getUserManagementData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.userManagementurl, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getCarrierAdmin() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.userdetailsurl + '/carrieradmin', options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getEmailsData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.emailLogsurl, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  activateUser(_userId) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.userManagementurl + "/activate/" + _userId, {}, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  deactivateUser(_userId) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    // console.log(options)
    return this.http.post(this.userManagementurl + "/deactivate/" + _userId, {}, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  SendForm(pageFilters: CompanyFilters) {
    // console.log(this.companyurl);
    // console.log(pageFilters);
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.companyurl, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getCompanyData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.companyurl, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getCompanyDetails() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.getcompanyurl, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  EditCompany(obj,comp) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.companyurl + "/" + comp, obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  DeleteCompany(_id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.delete(this.companyurl + "/" + _id, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  onCreateRole(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.URL + "userapi/user", obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  // getRoleData(){
  //   let options = new RequestOptions({ headers: this._headerService.getHeader() });
  //   return this.http.get(this.roleurl,options).pipe(map(response=>response.json()),catchError((error:Response)=>{return observableThrowError(error);}));
  // }
  getcompanyRoleData() {
    let options = new RequestOptions();
    return this.http.get(this.roleurl, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getallCompanyData() {
    let options = new RequestOptions();
    return this.http.get(this.companyurl, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  newCompanyregister(pageFilters: CompanyFilters) {
    let options = new RequestOptions();
    return this.http.post(this.newcompanyurl, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getcompanylistinfo(id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    // console.log(this.newcompanyurl + "/" + id);
    return this.http.get(this.newcompanyurl + "/" + id, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getcompanyroleinfo(cmpid, userid) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .get(this.newcompanyurl + "/" + cmpid + "/" + userid, options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  getUserdetails() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.userdetailsurl, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getUserroledetails(cmpid) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.userdetailsurl + "/" + cmpid, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getUserByRole(id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.userManagementurl + "/role/" + id, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  editrole(id, UserObj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.userdetailsurl + "/" + id, UserObj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  onCompanyValidate(token) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .get(this.currentEnv + "/company/validate/" + token, options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  forgotpassword(email: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(this.forgotpasswordurl, { email: email }, options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  resetpassword(body: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(this.resetpasswordurl, body , options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  onPasswordValidate(password, confirmPassword, token) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(
        this.validatepasswordurl,
        { password, confirmPassword, token },
        options
      )
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  getBCCompanyData(companyId: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.companyurl + "/bccompanies?companyId=" + companyId , options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  createBCCompany() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.companyurl + "/bccompany", "", options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updateUser(UserObj, id){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.userManagementurl + "/" + id, UserObj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  createUser(UserObj){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.userManagementurl, UserObj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  joinCompanyRequest(payload){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.userdetailsurl + "/companyjoinrequest", payload, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getCompanyConfigurationAllPlans(){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.companyconfigurationurl + "/allplan" , options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getCompanyConfiguration(){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.companyconfigurationurl , options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getCarrirRatecon(email){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.carrierRatecon+email , options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getCompanySubFeaturesList(subFeatures){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.companyconfigurationurl + "/subfeatures/" + subFeatures  , options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updateCustomSettings(obj){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.companyconfigurationurl + "/updateCustomSettings", obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updateSubscription(obj){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.companyconfigurationurl + "/updateSubscription", obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getTerms(){
    let url = environment.termsAndConditon
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
    map((response) => response.json()),
    catchError((error: Response) => {
      return observableThrowError(error);
      })
    );
  }

  saveTerms(terms){
    let obj ={
      description: terms,
      name: "Terms and Conditions"
    }
    let url = environment.termsAndConditon
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(url, obj, options).pipe(
    map((response) => response.json()),
    catchError((error: Response) => {
      return observableThrowError(error);
    })
  );

  }

  getCounters(){
    let url = environment.getCounter
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
    map((response) => response.json()),
    catchError((error: Response) => {
      return observableThrowError(error);
      })
    );
  }
  updateCounters(obj){
    let url = environment.updateCounter
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.patch(url, obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }


  typeAndSearch(message){
    let obj ={
      queryStr: message
  }
    let url = environment.typeAndSearch
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(url, obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );

  }
  getTokenInfo(token) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .get(this.userdetailsurl + "/token/" + token, options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  rejectCompanyJoinRequest(token) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .get(this.userdetailsurl + "/rejectedcompanyjoinrequest/" + token, options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  approveCompanyJoinRequest(token) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .get(this.userdetailsurl + "/approvedcompanyjoinrequest/" + token, options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  addCarrierAdmin(payload) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(this.userdetailsurl + "/addcarrieradmin", payload, options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  resetPassword(payload) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(this.userdetailsurl + "/adminresetpassword", payload, options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
}
